import { render, staticRenderFns } from "./ActiveUserRequests.vue?vue&type=template&id=4231b39d"
import script from "./ActiveUserRequests.vue?vue&type=script&lang=js"
export * from "./ActiveUserRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports